export const PLACEMENTS = {
  AUTO: 'auto',
  TOP: 'top',
  BOTTOM: 'bottom',
  LEFT: 'left',
  RIGHT: 'right',
  BOTTOM_LEFT: 'bottom-left',
  BOTTOM_RIGHT: 'bottom-right',
  TOP_LEFT: 'top-left',
  TOP_RIGHT: 'top-right',
  BOTTOM_CENTER: 'bottom-center',
  TOP_CENTER: 'top-center',
};

export const EDGE_THRESHOLDS = {
  RIGHT: 0.7,   // 70% of viewport width
  LEFT: 0.3,    // 30% of viewport width
  TOP: 0.15,    // 15% of viewport height
  BOTTOM: 0.85, // 85% of viewport height
};

export const DEFAULTS = {
  MAX_WIDTH: 320,
  DELAY: 300,
  Z_INDEX: 1000,
  EDGE_MARGIN: 10,
};

export const TOOLTIP_OFFSET = {
  'bottom-left': { x: 0.25, y: 0.5 },      // 25% from left, 50% from top
  'bottom-right': { x: -0.25, y: 0.5 },    // 25% from right, 50% from top
  'bottom-center': { x: 0.5, y: 1 },       // centered, below element
  'top-center': { x: 0.5, y: -1 },         // centered, above element
  'top-left': { x: 0.25, y: -1 },          // 25% from left, above element
  'top-right': { x: -0.25, y: -1 },        // 25% from right, above element
  'left': { x: -1, y: 0.5 },               // left of element, centered vertically
  'right': { x: 1, y: 0.5 },               // right of element, centered vertically
};
